import React from 'react';

import { PillButton } from '../../../../components/PillButton';
import { Reveal } from '../../../../components/Reveal';
import branding from '../../../../config/branding';
import { Heading, Inner, Lead, Note, Wrapper } from './styles';

const FinalCTA: React.FC = () => {
  return (
    <Wrapper id="cta">
      <Reveal direction="up">
        <Inner>
          <Heading>
            Pronto para modernizar a gestão e os treinos da sua academia?
          </Heading>
          <Lead>
            Comece agora mesmo seu teste gratuito de 15 dias. Sem cartão de
            crédito, sem burocracia e com acesso a todos os recursos.
          </Lead>

          <PillButton
            variant="solid"
            size="lg"
            href={`${branding.webUrl}/new-gym/`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Criar conta grátis agora
          </PillButton>

          <Note>
            Configuração em menos de 5 minutos • Cancele quando quiser
          </Note>
        </Inner>
      </Reveal>
    </Wrapper>
  );
};

export { FinalCTA };
